/**
 * Detects the client OS from the browser. Prefers the modern userAgentData API
 * (Chromium browsers) and falls back to parsing the user-agent string.
 */
export function isWindowsPlatform() {
  if (typeof navigator === 'undefined') return false;

  const uaPlatform = navigator.userAgentData?.platform;
  if (uaPlatform) return uaPlatform.toLowerCase() === 'windows';

  const ua = navigator.userAgent || navigator.platform || '';
  return /windows/i.test(ua);
}

// Explicit escape hatch for testing on non-Windows machines: ?allowMac=true
function hasPlatformOverride() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('allowMac') === 'true';
}

export function isPlatformAllowed() {
  return isWindowsPlatform() || hasPlatformOverride();
}
